import React, { useState } from 'react'
import { Input, FormCustom } from '../../Components/Form/Form'

const TypeFormatPrintForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id_type_format_print: data.id_type_format_print,
        p_name_format_print: data.name_format_print
    })

    return <FormCustom dataSubmit={row} onSubmit={onSubmit} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
        <Input
            text="Descripción"
            placeholder="Descripción"
            classNameParent="col-12 mb-2"
            icon="far fa-comment-alt"
            required
            invalid="El campo es obligatorio."
            defaultValue={data.name_format_print}
            onChange={e => setRow({ ...row, p_name_format_print: e.currentTarget.value })}
            maxLength={150}
        />
    </FormCustom>
}

TypeFormatPrintForm.defaultProps = {
    data: {
        id_type_format_print: '',
        name_format_print: ''
    },
    onSubmit: () => {},
    loadSubmit: false
}

export default TypeFormatPrintForm;